import produce from "immer";
import { CustomizationState } from "../";
import { SelectionPhoto } from "../../../types/selection/selection";
import { removeSelectionPhotoFromSelection } from "../../../utils/selection/photo";

export interface RemovePictureFromContentAction {
  pageKey?: string;
  selectionPhoto: SelectionPhoto;
  type: "removePictureFromContent";
}

const regexLocalId = /^local/i;

export function removePictureFromContent(
  state: CustomizationState,
  action: RemovePictureFromContentAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { selectionPhoto, pageKey } = action;

    draftState.content.pages = draftState.content.pages.map((page) => {
      if (pageKey && page.key !== pageKey) {
        return page;
      }

      // todo : when refactoring gallery, change local ids to definitive ids ? (see hack below)
      page.editablePictures = page.editablePictures.filter((editablePicture) => {
        const editablePicturePhotoKey = editablePicture.selectionPhotoKey;

        // hack : when a photo has just been added its local & temporary id may have been entered but distant id can be used
        let editablePictureSelectionPhoto: SelectionPhoto | null = null;
        if (regexLocalId.test(editablePicturePhotoKey)) {
          const distantSelectionPicture = draftState.selection.photos.find(
            (photo) => photo.key === editablePicturePhotoKey
          );
          if (distantSelectionPicture) {
            editablePictureSelectionPhoto = distantSelectionPicture;
          }
        }

        return !(
          editablePicturePhotoKey === selectionPhoto.key ||
          editablePicturePhotoKey === `${selectionPhoto.provider}-${selectionPhoto.providerRef}` ||
          (editablePictureSelectionPhoto &&
            `${editablePictureSelectionPhoto.provider}-${editablePictureSelectionPhoto.providerRef}` ===
              selectionPhoto.key)
        );
      });
      return page;
    });

    if (!pageKey) {
      removeSelectionPhotoFromSelection(selectionPhoto, draftState.selection);
    }
  });
}
